import { padStart } from 'lodash';
import { useMemo } from 'react';
import {
  COLOR_LABELS,
  ColorLabel,
  ImageQualityIndicator,
  Stage,
  SubClass,
} from '../../../../../../services/entities/impl/blfApi/schemas/stage';
import { generateAllCombinations } from '../utils/generateAllCombinations';

export const useRawCountStages = () => {
  return useMemo(() => {
    let index = 0;

    const res: Stage[] = [];

    // add stage definitions for flower stages
    const flowerStages: SubClass[] = ['open', 'closed', 'petalfall'];
    for (const flowerStage of flowerStages) {
      res.push({
        id: `${padStart(
          (index++).toString(),
          8,
          '0'
        )}-0000-0000-0000-000000000000`,
        name: flowerStage,
        className: 'flower',
        subClasses: [flowerStage],
        order: index,
      });
    }

    // Generate a stage definition for each color set combination (up to 3 colors)
    const allColorSetPermutations = generateAllCombinations(
      COLOR_LABELS as unknown as ColorLabel[],
      3
    );

    for (const color_sets of allColorSetPermutations) {
      const name = color_sets.join('-');
      res.push({
        id: `${padStart(
          (index++).toString(),
          8,
          '0'
        )}-0000-0000-0000-000000000000`,
        name,
        className: 'blueberry',
        colorSets: [color_sets],
        order: index,
      });
    }

    // add stage definitions for image quality indicators
    const imageQualityIndicators: ImageQualityIndicator[] = [
      'not-clear',
      'too-dark',
      'overexposed',
      'blurry',
    ];
    for (const indicator of imageQualityIndicators) {
      res.push({
        id: `${padStart(
          (index++).toString(),
          8,
          '0'
        )}-0000-0000-0000-000000000000`,
        name: indicator,
        className: 'blueberry',
        colorSets: [[indicator]],
        order: index,
      });
    }

    return res;
  }, []);
};
